/**
 * Хук для получения статуса рынка
 * ЗАЧЕМ: Централизованное получение market-status для всех индикаторов
 * Затрагивает: FuturesDataIndicator, OptionsDataIndicator
 */

import { useState, useEffect } from 'react';
import { getDatabentoHeaders, API_BASE_URL } from '../config/api';

let cachedStatus = null;
let cacheTimestamp = null;
let isFetching = false;
let fetchPromise = null;
const CACHE_DURATION = 60000; // 1 минута

const useMarketStatus = () => {
  const [status, setStatus] = useState(cachedStatus);
  const [loading, setLoading] = useState(!cachedStatus);

  useEffect(() => {
    const fetchMarketStatus = async () => {
      // Проверяем кеш
      const now = Date.now();
      if (cachedStatus && cacheTimestamp && (now - cacheTimestamp) < CACHE_DURATION) {
        setStatus(cachedStatus);
        setLoading(false);
        return;
      }

      // Если уже идет запрос, ждем его завершения
      if (isFetching && fetchPromise) {
        try {
          await fetchPromise;
          setStatus(cachedStatus);
          setLoading(false);
        } catch (error) {
          console.error('Ошибка ожидания статуса рынка:', error);
          setLoading(false);
        }
        return;
      }

      // Запускаем новый запрос
      isFetching = true;
      fetchPromise = (async () => {
        try {
          const response = await fetch(`${API_BASE_URL}/api/databento/market-status`, {
            headers: getDatabentoHeaders()
          });
          const data = await response.json();
          
          if (data.status === 'ok' || data.market_mode) {
            cachedStatus = data;
            cacheTimestamp = Date.now();
            setStatus(data);
          }
          setLoading(false);
        } catch (error) {
          console.error('Ошибка проверки статуса рынка:', error);
          setLoading(false);
        } finally {
          isFetching = false;
          fetchPromise = null;
        }
      })();

      await fetchPromise;
    };

    fetchMarketStatus();
    
    // Обновляем каждую минуту
    const interval = setInterval(fetchMarketStatus, 60000);
    return () => clearInterval(interval);
  }, []);

  return { status, loading };
};

export default useMarketStatus;
